import './TitledSection.less';
import React from 'react';


export default function TitledSection({title, description, children}) {

    return <div className="titled-section">
        {
            title &&
            <div className="header">
                <h2 className="title">{title}</h2>
                {
                    description &&
                    <div className="description">{description}</div>
                }
            </div>
        }
        <div className="body">{children}</div>
    </div>;
}
